import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { invalidateUserLevAdminGroups } from './useGetUserLevAdminGroups';

export interface IAddUserToLevAdminGroupRequest {
	userId: string;
	groupName: string;
}

export function useAddUserToLevAdminGroupMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: IAddUserToLevAdminGroupRequest) => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `admin/userOperations/${request.userId}/levAdminGroups/${request.groupName}`,
				}),
				'POST'
			);
		},
		onSuccess: (_, variables) => {
			invalidateUserLevAdminGroups(variables.userId);
		},
	});
}
